<template>
 <div>
  <ul class="list-group task-list">
   <li
    v-for="(task,idx) in tasks"
    v-bind:key="idx"
    class="list-group-item justify-content-between align-items-center p-0 cursor"
    @click="goTimer(task.id)"
   >
    <b-row class="py-1 m-0">
     <b-col cols="9" class="px-2" :class="[!task.project ? 'py-2' : '']">
			<span>{{task.title}}</span>
			<i
        v-if="task.priority != 'none'"
        class="material-icons small-icon ml-1"
        :class="`pri-${task.priority}`"
			>lens</i>
			<small class="d-block text-muted">{{task.project}}</small>
     </b-col>
      <b-col cols="3" class="p-0 pr-2 text-right" align-self="center">

				 <span
                class="badge badge-primary badge-pill"
                :class="[
                  isCompleteTask(task)
                    ? 'bg-success'
                    : task.is_due
                    ? 'bg-danger'
                    : 'bg-primary',
                ]"
                >{{ getHourOrDate(task) }}</span
              >
      </b-col>
    </b-row>
   </li>
  </ul>
 </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex"

export default {
 props: {
  tasks: {
   type: Array,
   required: true
  },
  isToday:{
    type:Boolean,
    default:false
  }
 },
 data: function() {
  return {
  }
 },
 computed: {
   ...mapGetters('general', ['getFormattedDate', 'formatAMPM'])
 },
 methods: {
  isCompleteTask(task) {
    let response = task.state >= 4;
    return response;
  },
  getHourOrDate(task) {
    let to_return = "";
    if (this.isToday) {
      to_return = this.formatAMPM(task.date);
    } else {
      to_return = this.getFormattedDate(task.date);
    }
    return to_return;
  },
	goTimer(id){
		this.$router.push({
			name: 'task-timer',
			params: { Tid: id}
		});
	}
 }
}
</script>
